import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { StandardTeamFeatures } from "@common/ADAPT.Common.Model/organisation/team-type";

export enum TeamTypeCode {
    Team = "TEAM",
    Leadership = "LEADERSHIP",
    KeyFunction = "KEYFUNCTION",
    ValueStream = "VALUESTREAM",
}

export class TeamTypeCodeMetadata {
    public static readonly DefaultFeatures: { [key in TeamTypeCode]: FeatureName[] } = {
        [TeamTypeCode.Team]: [...StandardTeamFeatures],
        [TeamTypeCode.Leadership]: [...StandardTeamFeatures],
        [TeamTypeCode.KeyFunction]: [
            FeatureName.OrganisationTeam,
            FeatureName.ArchitectureRoles,
            FeatureName.ArchitectureSystem,
            FeatureName.PurposeAndVision,
        ],
        [TeamTypeCode.ValueStream]: [
            FeatureName.OrganisationTeam,
            FeatureName.ArchitectureRoles,
            FeatureName.ArchitectureSystem,
            FeatureName.PurposeAndVision,
        ],
    };
}
